import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class StatusPage extends Component {

    constructor() {
        super();
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        this.dialogClose = () => {
            this.setState({
                hideUndeployConfirmation: false,
                displayPendingPaymentModal: false,
                dispUnlistAppConfirmation: false
            });
        };
        this.undeployButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.undeployProjectAPi();
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideUndeployConfirmation: false });
            }
        }];

        this.unlistApp = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.setState({ hideUndeployConfirmation: true })
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ dispUnlistAppConfirmation: false });
            }
        }];

        this.state = {
            permissionNotGranted: false,
            isNotAuthorisedDisabled: true,
            planName: null,
            showTextArea: false,
            status: null,
            percentage: 0,
            error: null,
            numOfBot: 0,
            numOfVoiceBot: 0,
            deploySuccess: false,
            totalNumOfBots: 0,
            reqNumOfBots: 0,
            errorMessage: null,
            showPayToWallet: false,
            advanceAmt: 0,
            paymentParams: [],
            prevDeploysNoOfBot: 0,
            currentProjectPlan: null,
            prevProjectPlan: null,
            convAiDiscount: 0,
            billingType: null,
            planAmount: 0,
            displayCredits: false,
            monthlyChecked: false,
            yearlyChecked: false,
            walletBalance: 0,
            subscriptionId: null,
            voiceBotChecked: false,
            subscriptionPlanName: null,
            addVoiceCapability: false,
            planAmountAfterDiscount: 0,
            disableDeploy: false,
            disableReDeploy: false,
            hideUndeployConfirmation: false,
            isSuspended: false,
            isDeleted: false,
            minimumCommitment: null,
            showNumberOfAgent: false,
            deployAgentClickCount: 0,
            isNotAuthorised: false,
            paymentLinkEmail: '',
            isPendingPayment: false,
            successResp: false,
            invalidBillingSettingEmail: false,
            isProjectWalletLessThanMinBal: false,
            displayPendingPaymentModal: false,
            projectHasApp: false,
            dispUnlistAppConfirmation: false,
            utteranceData: [
                {
                    noOfIncomingUtterance: "0-10000",
                    price: "₹ 0.20"
                },
                {
                    noOfIncomingUtterance: "10000 to  2 Lakhs",
                    price: "₹ 0.15"
                },
                {
                    noOfIncomingUtterance: "2 Lakhs and above",
                    price: "₹ 0.10"
                }
            ],
            cost: "₹ " + 0.0
        }
    }


    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            this.fetchProjectBillingSettingApi();
            this.fetchSelectedProjectPlanApi();
            this.fetchProjectDetailsApi();
            this.fetchPaymentpropertyApi();
            this.fetchBillingTypeApi();
            this.fetchProjectVoiceSettingApi();
            this.fetchPlanAmountApi();
            this.fetchDeployedBotsNumberApi();
            this.fetchInvoicesApi();
            this.fetchTeamMembershipApi();
            this.fetchAppStoreDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchProjectBillingSettingApi(event.projectId);
            thisController.fetchSelectedProjectPlanApi(event.projectId);
            thisController.fetchAppStoreDataApi(event.projectId);
            thisController.state.showTextArea = false;
            thisController.state.prevDeploysNoOfBot = 0;
            thisController.state.status = null;
            thisController.state.percentage = 0;
            thisController.state.error = null;
            thisController.state.numOfBot = 0;
            thisController.state.totalNumOfBots = 0;
            thisController.state.displayCredits = false;
            thisController.state.isSuspended = false;
            thisController.state.isDeleted = false;
            thisController.state.isNotAuthorised = false;
            thisController.setState(thisController.state);
            thisController.fetchProjectDetailsApi();
            thisController.fetchBillingTypeApi();
            thisController.fetchProjectVoiceSettingApi();
            thisController.fetchPlanAmountApi();
            thisController.fetchDeployedBotsNumberApi();
            thisController.fetchInvoicesApi();
            thisController.fetchTeamMembershipApi();

        });
        document.addEventListener("keydown", this.escFunction, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    fetchProjectBillingSettingApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let data = { projectId: projectId }
        let statusComponent = this;
        statusComponent.state.invalidBillingSettingEmail = false;
        $.ajax({
            url: "/api/project-billing-setting",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    statusComponent.state.isNotAuthorisedDisabled = false;
                    statusComponent.state.paymentLinkEmail = res.result.projectBillingSettings.emailId;
                    var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
                    if (statusComponent.state.paymentLinkEmail != null) {
                        if (!pattern.test(statusComponent.state.paymentLinkEmail)) {
                            statusComponent.state.invalidBillingSettingEmail = true;
                        } else {
                            statusComponent.state.invalidBillingSettingEmail = false;
                        }
                    } else {
                        statusComponent.state.invalidBillingSettingEmail = true;
                    }
                    statusComponent.setState(statusComponent.state);
                } else {
                    if (data.projectId != "00000000-0000-0000-0000-000000000000") {
                        statusComponent.state.isNotAuthorisedDisabled = true;
                        statusComponent.notifyBillingSettingsNotAdded("Please fill in the mandatory information in the billing settings page")
                        setTimeout(function () {
                            window.location.href = '/platform/projectmgmt/billing-setting';
                        }, 3000);
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchProjectDetailsApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/project-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.currentProjectPlan = res.result.projectPlan;
                    statusController.setState(statusController.state);
                    if (res.result.deployed == true) {
                        statusController.projectDeployDetails();
                    } else {
                        statusController.state.deploySuccess = false;
                        statusController.setState(statusController.state);
                    }
                    if (res.result.suspended) {
                        statusController.state.isSuspended = true;
                    } else if (res.result.deleted) {
                        statusController.state.isDeleted = true;
                    }
                } else {
                    statusController.printGeneralErrorMessage();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchBillingTypeApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/project-billing-type",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.billingType = res.result.billingType;
                    statusController.state.cost = "₹ " + res.result.fixedMonthlyCost;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    escFunction = (event) => {
        if (event.keyCode === 27) {
            if (this.state.showPayToWallet) {
                this.setState({ showPayToWallet: false });
            }
        }
    }

    projectDeployDetails = () => {
        var statusController = this;
        $.ajax({
            url: "/api/project-deploy-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.prevDeploysNoOfBot = res.result.projectDeployment.numberOfBots;
                    statusController.state.addVoiceCapability = res.result.projectDeployment.addVoiceCapability;
                    statusController.state.prevProjectPlan = res.result.projectDeployment.projectPlan;
                    statusController.state.deploySuccess = true;

                    var inProgress = true;
                    if (res.result.projectDeployment.status == "ERROR") {
                        inProgress = false;
                    } if (res.result.projectDeployment.status == "COMPLETE") {
                        inProgress = false;
                    }
                    if (inProgress) {
                        statusController.state.showTextArea = true;
                        statusController.state.status = res.result.projectDeployment.status;
                        statusController.state.percentage = res.result.projectDeployment.percentage;
                        statusController.state.errorMessage = res.result.projectDeployment.errorMessage;
                        statusController.state.reqNumOfBots = res.result.projectDeployment.requiredNumberOfBots;
                        statusController.state.totalNumOfBots = res.result.projectDeployment.numberOfBots;
                    }
                    statusController.setState(statusController.state);
                } else {
                    statusController.state.showTextArea = false;
                    statusController.state.status = null;
                    statusController.state.percentage = 0;
                    statusController.state.errorMessage = null;
                    statusController.state.deploySuccess = false;
                    statusController.state.numOfBot = 0;
                    statusController.state.totalNumOfBots = 0;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    printGeneralErrorMessage = () => {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    printDeployStatusFetchError() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Snap! Some error occured when trying to get deploy status...</b>, {
            position: "top-center",
            color: "red"

        });
    }

    changePlan = (e) => {
        window.location.href = '/platform/project-plan-settings/';
        localStorage.setItem("previousPath", "launchpad")
    }

    NotifyFailToLoad(response) {
        if (/null/i.test(response)) {
            this.printGeneralErrorMessage();
        } else {
            toast.dismiss();
            toast(<b style={{ color: "red" }}>{response}</b>, {
                position: "top-center",
                color: "red"

            });
        }
    }

    fetchSelectedProjectPlanApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var statusController = this;
        $.ajax({
            url: "/api/project-plan-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.planName = res.result;
                    statusController.setState(statusController.state);
                } else {
                    statusController.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deployProjectAPi = () => {
        let statusController = this;
        let data = {
            projectId: localStorage.getItem("currentProjectId"),
            addVoiceCapability: statusController.state.voiceBotChecked
        }
        $.ajax({
            url: "/api/deploy-project",
            type: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                statusController.state.disableDeploy = false;
                statusController.setState(statusController.state);
                if (res.success === true) {
                    statusController.state.showTextArea = true;
                    res = res.result;
                    statusController.state.percentage = res.percentage;
                    statusController.state.deployId = res.deploymentId;
                    statusController.state.status = res.status;
                    statusController.setState(statusController.state);
                    if (res.status != 'COMPLETE') {
                        statusController.deployStatusApi();
                    } else {
                        statusController.projectDeployDetails();
                        statusController.fetchDeployedBotsNumberApi();
                        statusController.setState({ deploySuccess: true })
                    }
                } else if (res.result == "false" || res.result == false) {
                    statusController.state.showPayToWallet = true;
                    statusController.setState(statusController.state);
                } else {
                    statusController.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deployStatusApi = () => {
        let statusController = this;
        $.ajax({
            url: "/api/deploy-status",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: {
                deployId: statusController.state.deployId
            },
            success: function (res) {
                if (res.success === true) {
                    res = res.result;
                    statusController.state.percentage = res.percentage;
                    statusController.state.totalNumOfBots = res.numberOfBots;
                    statusController.state.reqNumOfBots = res.requiredNumberOfBots;
                    statusController.state.status = res.status;

                    if (res.status == 'COMPLETE') {
                        statusController.state.percentage = res.percentage;
                        statusController.state.deployId = res.deploymentId;
                        statusController.state.status = res.status;
                        statusController.state.deploySuccess = true;
                        statusController.setState(statusController.state);
                        statusController.projectDeployDetails();
                        statusController.fetchDeployedBotsNumberApi();
                    } else if (res.status == 'ERROR') {
                        statusController.state.errorMessage = res.errorMessage;
                        statusController.state.status = "error";
                        statusController.setState(statusController.state);
                        statusController.printDeployStatusFetchError();
                    } else if (res.errorMessage !== null) {
                        statusController.printDeployStatusFetchError();
                    } else {
                        window.deployStatusTimeoutHandle = setTimeout(function () {
                            statusController.deployStatusApi();
                        }, 1000);
                    }
                    statusController.setState(statusController.state);
                } else {
                    statusController.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    undeployProjectAPi = () => {
        let statusController = this;
        $.ajax({
            url: "/api/undeploy-project",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.setState({ hideUndeployConfirmation: false, numOfBot: 0 });
                    statusController.notifyUpdateSuccessMsg("Project undeployed successfully");
                    setTimeout(() => {
                        statusController.setState({ deploySuccess: false })
                    }, 2000);

                } else {
                    statusController.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    closeshowPayToWallet = () => {
        var statusController = this;
        statusController.state.showPayToWallet = false;
        statusController.setState(statusController.state);
    }
    fetchPaymentpropertyApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/payment-params",
            async: false,
            method: 'GET',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.paymentParams = res.result;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    makePayment = () => {
        var statusController = this;
        let userDetails = JSON.parse(localStorage.getItem("user_details"));
        var themeImage = "/platform/assets/images/favicon.png";
        var advanceAmount = statusController.state.planAmountAfterDiscount;

        var options = {
            "key": statusController.state.paymentParams["keyId"],
            "amount": advanceAmount * 100,
            "name": statusController.state.paymentParams["name"],
            "description": statusController.state.paymentParams["description"],
            "image": themeImage,
            "handler": function (response) {
                var paymentId = response.razorpay_payment_id;
                statusController.state.paymentId = paymentId;
                statusController.setState(statusController.state);
                statusController.capturePaymentAPi(paymentId, advanceAmount)
            },
            "prefill": {
                "name": userDetails["name"],
                "email": userDetails["emailId"],
                "contact": userDetails["mobileNumber"]
            },
            "notes": {
                "address": userDetails["address"]
            },
            "theme": {
                "color": "#93D2FA"
            }
        };
        var rzpy = new window.Razorpay(options);
        rzpy.on('payment.failed', function (response) {
            statusController.saveFailedPaymentApi(response.error.metadata.payment_id, advanceAmount);
        });
        rzpy.open();
    }

    capturePaymentAPi = (paymentId, advanceAmount) => {
        var statusController = this;
        statusController.closeshowPayToWallet();
        let userDetails = JSON.parse(localStorage.getItem("user_details"));
        var date = new Date();
        var paymentDate = new Date(date.toDateString()).getTime();
        var data = {
            paymentId: paymentId,
            paymentDate: paymentDate,
            projectId: localStorage.getItem("currentProjectId"),
            name: userDetails["name"],
            phoneNumber: userDetails["mobileNumber"],
            walletBalance: advanceAmount,
            organizationId: localStorage.getItem("organizationId"),
            userEmailId: JSON.parse(localStorage.getItem("user_details"))["emailId"]
        };
        $.ajax({
            url: "/api/capture-wallet-payment",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: JSON.stringify(data),
            success: function (res) {
                if (res.success === true) {
                    statusController.notifyUpdatePaymentSuccess("Payment of " + res.result + " is successfull");
                    var statusPageInterval = setTimeout(function () {
                        clearTimeout(statusPageInterval);
                        statusController.state.errorMessage = null;
                        statusController.deployProjectAPi();
                        statusController.state.showTextArea = true;
                        statusController.setState(this.state);
                    }, 3000);
                } else {
                    statusController.printGeneralErrorMessage();
                    statusController.state.showPayToWallet = false;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        })
    }

    saveFailedPaymentApi = (paymentId, advanceAmount) => {
        var statusController = this;
        statusController.closeshowPayToWallet();
        let userDetails = JSON.parse(localStorage.getItem("user_details"));
        var date = new Date();
        var paymentDate = new Date(date.toDateString()).getTime();
        var data = {
            paymentId: paymentId,
            paymentDate: paymentDate,
            projectId: localStorage.getItem("currentProjectId"),
            name: userDetails["name"],
            phoneNumber: userDetails["mobileNumber"],
            walletBalance: advanceAmount,
            organizationId: localStorage.getItem("organizationId"),
            userEmailId: JSON.parse(localStorage.getItem("user_details"))["emailId"]
        };
        $.ajax({
            url: "/api/failed-payment",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: JSON.stringify(data),
            success: function (res) {

            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        })
    }


    notifyUpdatePaymentSuccess(message) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }
    notifyUpdateSuccessMsg(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }

    fetchPlanAmountApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/get-plan-amount",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId"),
                "billingInterval": 'MONTHLY_PLAN'
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.planAmountAfterDiscount = res.result.planAmount;
                    statusController.getAdvanceProperties();
                } else {
                    statusController.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    checkHandleNotAuthorised = () => {
        if (!this.state.isNotAuthorised) {
            this.state.isNotAuthorised = true;
            this.setState(this.state);
        } else {
            this.state.isNotAuthorised = false;
            this.setState(this.state);
        }
    }

    delayOnClickDeploy = () => {
        var statusComponent = this;
        if (statusComponent.state.permissionNotGranted) {
            statusComponent.state.disableDeploy = true;
            statusComponent.setState(statusComponent.state);

            if (statusComponent.state.planName == "FREE") {
                setTimeout(() => {
                    statusComponent.state.disableDeploy = false;
                    statusComponent.setState(statusComponent.state);
                    statusComponent.deployProjectAPi();
                }, 3000);
            } else {
                statusComponent.deployProjectAPi();
            }
        } else {
            statusComponent.notifyErrorMsg("Deploy permission is not granted for this role");
        }
    }

    delayOnClickReDeploy = () => {
        if (this.state.permissionNotGranted) {
            if (!this.state.isPendingPayment) {
                this.state.disableReDeploy = true;
                this.setState(this.state);
                var statusComponent = this;
                if (statusComponent.state.planName == "FREE") {
                    setTimeout(() => {
                        statusComponent.state.disableReDeploy = false;
                        statusComponent.setState(statusComponent.state);
                        statusComponent.reDeployProject();
                    }, 3000);
                } else {
                    statusComponent.reDeployProject();
                }
            } else {
                this.state.displayPendingPaymentModal = true;
                this.setState(this.state);
            }
        } else {
            this.notifyErrorMsg("Redeploy permission is not granted for this role");
        }
    }

    fetchProjectVoiceSettingApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/voice-settings",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        statusController.state.voiceBotChecked = res.result.enabled;
                        statusController.setState(statusController.state);
                    } else {
                        statusController.state.voiceBotChecked = false;
                        statusController.setState(statusController.state);
                    }
                } else {
                    statusController.state.voiceBotChecked = false;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    verifyMinimumBalanceApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/verify-plan-minimum-balance",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success == true) {
                    statusController.state.isProjectWalletLessThanMinBal = res.result;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }


    notifySuspendedProject = () => {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;
            Your project has been suspended due to negative project wallet balance, Please recharge via payment link which you got in the mail.
        </b>, {
            position: "top-center"
        });
    }

    reDeployProject = () => {
        let statusController = this;
        let data = {
            projectId: localStorage.getItem("currentProjectId"),
            addVoiceCapability: statusController.state.voiceBotChecked
        }
        $.ajax({
            url: "/api/re-deploy-project",
            type: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                statusController.state.disableReDeploy = false;
                statusController.setState(statusController.state);
                if (res.success === true) {
                    statusController.state.showTextArea = true;
                    res = res.result;
                    statusController.state.percentage = res.percentage;
                    statusController.state.deployId = res.deploymentId;
                    statusController.state.status = res.status;
                    statusController.setState(statusController.state);
                    if (res.status != 'COMPLETE') {
                        statusController.deployStatusApi();
                    } else {
                        statusController.projectDeployDetails();
                        statusController.fetchDeployedBotsNumberApi();
                        statusController.setState({ deploySuccess: true })
                    }
                } else if (res.result == "false" || res.result == false) {
                    statusController.state.showPayToWallet = true;
                    statusController.setState(statusController.state);
                } else {
                    statusController.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchDeployedBotsNumberApi = () => {
        var statusController = this;
        $.ajax({
            url: "/api/deployed-bots-number",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusController.state.numOfBot = res.result;
                    statusController.setState(statusController.state);
                } else {
                    statusController.state.numOfBot = 0;
                    statusController.setState(statusController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onClickDeployAgent = () => {
        this.state.deployAgentClickCount = this.state.deployAgentClickCount + 1;
        this.setState(this.state);
        if (this.state.deployAgentClickCount == 6) {
            this.state.showNumberOfAgent = true;
            this.setState(this.state);
        }
    }

    onMouseMoveOut = () => {
        this.state.deployAgentClickCount = 0;
        this.setState(this.state);
    }

    sendPaymentLinkApi = () => {
        var statusController = this;
        var advanceAmount = parseFloat(statusController.state.planAmountAfterDiscount);

        $.ajax({
            url: "/api/send-payment-link",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: {
                projectId: localStorage.getItem("currentProjectId"),
                userId: JSON.parse(localStorage.getItem("user_details"))["userId"],
                amount: advanceAmount * 100,
                userEmailId: statusController.state.paymentLinkEmail
            },
            success: function (res) {
                if (res.success === true) {
                    statusController.notifyUpdateSuccessMsg("Payment link has been sent to the emailId you submitted, Your project will be deployed once payment is successful");
                    statusController.state.isPendingPayment = true;
                    statusController.setState(statusController.state);
                } else {
                    statusController.notifyErrorMsg(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }

        });
    }

    notifyErrorMsg = (errorMsg) => {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{errorMsg}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyBillingSettingsNotAdded = (message) => {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;
            {message}
        </b>, {
            position: "top-center"
        });
    }

    fetchInvoicesApi = () => {
        var statusComponent = this;
        $.ajax({
            url: "/api/get-invoice-reciept",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    statusComponent.state.successResp = true;
                    if (res.result.pending.length > 0) {
                        statusComponent.state.isPendingPayment = true;
                    } else {
                        statusComponent.state.isPendingPayment = false;
                    }
                    statusComponent.setState(statusComponent.state);
                } else {
                    statusComponent.state.isPendingPayment = false;
                    statusComponent.setState(statusComponent.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        })
    }

    notifyDeletedProject = () => {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;
            You cannot deploy a deleted project
        </b>, {
            position: "top-center"
        });
    }

    getAdvanceProperties = () => {
        var statusComponent = this;
        $.ajax({
            url: "/api/get-wallet-refill-amount-value",
            async: false,
            method: 'GET',
            data: { "projectId": localStorage.getItem("currentProjectId") },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (Number(res.result.discountedWalletRefillAmt) > 0) {
                        statusComponent.state.planAmountAfterDiscount = Number(res.result.discountedWalletRefillAmt);
                        statusComponent.setState(statusComponent.state);
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchTeamMembershipApi = () => {
        var statusPageComponent = this;

        $.ajax({
            url: "/api/project-membership",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem("currentProjectId"),
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        if ((res.result[i].role == "PROJECT_ADMIN" && res.result[i].userEmail == JSON.parse(localStorage.getItem("user_details"))["emailId"]) ||
                            (res.result[i].role == "PROJECT_DEVELOPER" && res.result[i].userEmail == JSON.parse(localStorage.getItem("user_details"))["emailId"]) ||
                            res.result[i].role == "ROOT_ADMIN" && res.result[i].userEmail == JSON.parse(localStorage.getItem("user_details"))["emailId"]) {
                            statusPageComponent.state.permissionNotGranted = true;
                            statusPageComponent.setState(statusPageComponent.state);
                        }
                    }
                } else {
                    statusPageComponent.NotifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    onClickRedeploy = () => {
        var statusComponent = this;
        if (statusComponent.state.isDeleted) {
            statusComponent.notifyDeletedProject();
        } else {
            statusComponent.delayOnClickReDeploy();
        }
    }

    onClickDeploy = () => {
        var statusComponent = this;
        if (statusComponent.state.isDeleted) {
            statusComponent.notifyDeletedProject();
        } else {
            statusComponent.delayOnClickDeploy();
        }
    }

    fetchAppStoreDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var statusComponent = this;
        $.ajax({
            url: "/api/app",
            async: false,
            method: 'GET',
            data: {
                templateProjectId: projectId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    statusComponent.state.fields = res.result.app;
                    if (Object.keys(res.result.app).length > 0) {
                        statusComponent.state.projectHasApp = res.result.app.listed;
                    } else {
                        statusComponent.state.projectHasApp = false;
                    }
                } else {
                    statusComponent.state.projectHasApp = false;
                }
                statusComponent.setState(statusComponent.state);
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    checkIsAnApp = () => {
        if (this.state.projectHasApp) {
            this.setState({ dispUnlistAppConfirmation: true })
        } else {
            this.setState({ hideUndeployConfirmation: true })
        }
    }

    render() {
        var status = this.state.status;
        if (status != null || status != undefined) {
            if (/_/i.test(status)) {
                var replUnSc = status.split("_").join(" ");
                status = replUnSc.split(' ')
                    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                    .join(' ')
            } else {
                status = status[0].toUpperCase() + status.substr(1).toLowerCase()
            }
        }

        const utteranceBasedColumns = [
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Number of Incoming Utterances</b></div>),
                accessor: 'noOfIncomingUtterance',
                sortable: false,
                style: { textAlign: "center" },
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.noOfIncomingUtterance}</div>
                )
            },
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>Price per Utterance</b></div>),
                accessor: 'price',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', textAlign: "center" }}
                    type="text"
                >{props.original.price}</div>
                )
            },
        ]

        const fixedMonthlyColumns = [
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>COST</b></div>),
                accessor: 'costLabel',
                sortable: false,
                style: { textAlign: "center" }
            },
            {
                Header: () => (<div style={{ textAlign: "center" }}><b>{this.state.cost}</b></div>),
                accessor: 'cost',
                sortable: false,
                style: { textAlign: "center" }
            }
        ]

        return (
            <div>
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <div className="row" style={{ display: this.state.successResp ? 'block' : 'none' }}>
                    <div className="col-12">
                        {/* Custom Tabs */}
                        <h6 className="nav-item"
                            onClick={this.onClickDeployAgent}
                            onMouseOut={this.onMouseMoveOut}
                            style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '20px', cursor: 'pointer'
                            }}>Deploy your agents</h6>

                        <ToastContainer className="Toast-at-center" />

                        <div className="card-body p-0 mb-25" style={{ marginLeft: "20px" }}>
                            <div className="tab-content col-12 p-0">
                                <div className="tab-pane active show" id="tab_1">
                                    <div className="card card-primary mt-3">
                                        <div className="card-body raise-form">

                                            <div className="row">
                                                <div className="col-sm-10" style={{
                                                    display: this.state.billingType == "UTTERANCE_BASED" || this.state.billingType == "FIXED_PRICE"
                                                        ? 'none' : 'block'
                                                }}>
                                                    <div style={{
                                                        display: this.state.showNumberOfAgent ? 'block' : 'none'
                                                    }}>
                                                        <div className="row">
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginTop: '10px', marginLeft: '30px'
                                                            }}>Number of Agents :
                                                            </h6>
                                                            <input type="text"
                                                                value={this.state.numOfBot}
                                                                disabled={true}
                                                                style={{
                                                                    marginLeft: '10px',
                                                                    borderBottom: 'none',
                                                                    width: "100px",
                                                                    padding: '5px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        display: this.state.isPendingPayment || this.state.deploySuccess ||
                                                            this.state.planAmountAfterDiscount <= 0 ? 'none' : 'block'
                                                    }}>
                                                        <div style={{ display: this.state.planName === "FREE" ? 'none' : 'block' }}>
                                                            <div className="row">
                                                                {/* <label class="switch"> */}
                                                                <input style={{
                                                                    marginLeft: '30px', marginTop: '5px',
                                                                    width: '20px', height: '30px', backgroundColor: '#282a65'
                                                                }}
                                                                    disabled={this.state.isNotAuthorisedDisabled}
                                                                    type="checkbox"
                                                                    onChange={this.checkHandleNotAuthorised}
                                                                    checked={this.state.isNotAuthorised}
                                                                />

                                                                <h6 className="nav-item" style={{
                                                                    color: '#282a65',
                                                                    marginTop: '10px', marginLeft: '10px'
                                                                }}>
                                                                    I'm not authorised to make payments
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ display: this.state.isNotAuthorised ? 'flex' : 'none' }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginTop: '10px', marginLeft: '30px'
                                                            }}>
                                                                We shall send a payment link to the email address of the authorized person as configured in the billing settings.
                                                            </h6>
                                                            <br /><br />
                                                        </div>
                                                        <button className="btn action-button"
                                                            disabled={this.state.isPendingPayment}
                                                            style={{ marginLeft: '22px', display: this.state.isNotAuthorised ? 'block' : 'none' }}
                                                            onClick={this.sendPaymentLinkApi}>
                                                            Submit
                                                        </button>
                                                    </div>
                                                    <div className="row" style={{ display: this.state.isPendingPayment && !this.state.deploySuccess ? 'block' : 'none' }}>
                                                        <h6 className="nav-item" style={{
                                                            color: '#282a65',
                                                            marginTop: '10px', marginLeft: '30px'
                                                        }}>
                                                            There is an invoice pending payment for this project. Please go to <a href={window.origin + "/platform/invoice"}>/myaccounts/invoice</a> and make the payment before deploying your project
                                                        </h6>
                                                    </div>

                                                </div>
                                                <div className="col-sm-10" style={{
                                                    display: this.state.billingType == "UTTERANCE_BASED" || this.state.billingType == "FIXED_PRICE"
                                                        ? 'block' : 'none'
                                                }}></div>
                                                <div className="d-flex flex-row-reverse pt-2 col-sm-2" align="right">
                                                    <button className="btn action-button"
                                                        style={{ display: this.state.isPendingPayment || this.state.deploySuccess || this.state.isNotAuthorised ? "none" : "block" }}
                                                        onClick={this.onClickDeploy}
                                                        disabled={this.state.disableDeploy}>
                                                        Deploy
                                                    </button>

                                                    <button className="btn"
                                                        onMouseEnter={e => {
                                                            this.setState({ isHover: true })
                                                        }}
                                                        onMouseLeave={e => {
                                                            this.setState({ isHover: false })
                                                        }}
                                                        style={{
                                                            margin: "5px", height: "40px",
                                                            display: this.state.deploySuccess ? "block" : "none", backgroundColor: "#696969",
                                                            color: this.state.isHover ? "#FFD700" : "#ffffff"
                                                        }}
                                                        onClick={this.checkIsAnApp}>
                                                        Undeploy
                                                    </button>

                                                    <button className="btn action-button"
                                                        style={{ display: this.state.deploySuccess ? "block" : "none" }}
                                                        onClick={this.onClickRedeploy}
                                                        disabled={this.state.disableReDeploy}>
                                                        Redeploy
                                                    </button>

                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-sm-6" style={{ display: this.state.showTextArea ? "block" : "none" }}>
                                                        <div className="col-sm-8" style={{
                                                            marginTop: "40px", marginLeft: '20px'
                                                        }}>
                                                            <Progress
                                                                style={{ display: this.state.showTextArea ? 'block' : 'none' }}
                                                                id="deploy"
                                                                width="600px"
                                                                height="50px"
                                                                rectBorderRadius="1px"
                                                                percent={parseInt(this.state.percentage)}
                                                            />
                                                        </div>
                                                        <div className="col-sm-8" style={{
                                                            marginTop: "40px", marginLeft: '20px'
                                                        }}>
                                                            <textarea
                                                                style={{
                                                                    display: this.state.showTextArea ? 'block' : 'none',
                                                                    background: 'white', resize: 'none', height: this.state.errorMessage !== null ? "85px" : "67px",
                                                                    fontSize: "0.891em"
                                                                }}
                                                                className="form-control"
                                                                value={this.state.errorMessage !== null ? "Required number of agents : "
                                                                    + this.state.reqNumOfBots + '\n' + "Total number of agents : " +
                                                                    this.state.totalNumOfBots + '\n' + "Overall Status : "
                                                                    + status + '\n' + "Error message : " + this.state.errorMessage : "Required number of agents : "
                                                                    + this.state.reqNumOfBots + '\n' + "Total number of agents : " +
                                                                    this.state.totalNumOfBots + '\n' + "Overall Status : "
                                                                + status} />
                                                        </div>
                                                    </div>


                                                    <div style={{ display: this.state.billingType == "UTTERANCE_BASED" || this.state.billingType == "FIXED_PRICE" ? 'none' : 'block' }}>

                                                        <div style={{
                                                            display: this.state.planName === "STARTER" ? "block" : "none"
                                                        }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginLeft: '23px', marginTop: "10px"
                                                            }}>Your selected plan:</h6><br />
                                                            <div className="priceCard tborder primeclr" style={{ marginLeft: '23px', minHeight: "600px" }}>
                                                                <div className="pric_head">
                                                                    <h3 className="planTitle" style={{ color: "blue" }}>{this.state.planName}</h3>
                                                                    <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB" }}>
                                                                        <span><b>₹ 2,000</b></span>
                                                                        <span style={{ fontSize: "16px" }}> / recharge</span>
                                                                    </h4>
                                                                    <table id="customers">
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <th className="planPrice" colSpan="2"
                                                                                style={{ fontSize: "16px", color: '#0d66d5', background: 'transparent', textAlign: 'center' }}>Usage Charges</th>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px", width: '50%' }}>
                                                                            <td>Text Chat</td>
                                                                            <td>₹ 1.1 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Voice Chat</td>
                                                                            <td>₹ 1.95 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Asr Api</td>
                                                                            <td>₹ 1.75 / minute</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                <div className="pric_body">
                                                                    <ul className="priceFeature" id="starterPlan">
                                                                        <li>Agent on website widget &amp; popular social platforms</li>
                                                                        <li>2 Languages(e.g English and Hindi)</li>
                                                                        <li>20 FAQs</li>
                                                                        <li>2 Intents</li>
                                                                        <li>Dashboard with reports</li>
                                                                        <li>Delegate chat to humans</li>
                                                                        <li>Unlimited messages</li>
                                                                    </ul>
                                                                </div>
                                                                <div className="pric_footer">
                                                                    <button className="btn btn-arrow" onClick={this.changePlan}>
                                                                        <span>Change Plan
                                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                                                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style={{
                                                            display: this.state.planName === "PROFESSIONAL" ? "block" : "none"
                                                        }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginLeft: '23px', marginTop: "10px"
                                                            }}>Your selected plan:</h6><br />
                                                            <div className="priceCard tborder primeclr" style={{ marginLeft: '23px', minHeight: "600px" }}>
                                                                <div className="pric_head">
                                                                    <h3 className="planTitle" style={{ color: "blue" }}>{this.state.planName}</h3>
                                                                    <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB" }}>
                                                                        <span><b>₹ 4,000</b></span>
                                                                        <span style={{ fontSize: "16px" }}> / recharge</span>
                                                                    </h4>
                                                                    <table id="customers">
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <th className="planPrice" colSpan="2"
                                                                                style={{ fontSize: "16px", color: '#0d66d5', background: 'transparent', textAlign: 'center' }}>Usage Charges</th>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px", width: '50%' }}>
                                                                            <td>Text Chat</td>
                                                                            <td>₹ 1 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Voice Chat</td>
                                                                            <td>₹ 1.95 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Asr Api</td>
                                                                            <td>₹ 1.75 / minute</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                <div className="pric_body">
                                                                    <ul className="priceFeature" id="professionPlan">
                                                                        <li>Agent on website widget &amp; popular social platforms</li>
                                                                        <li>4 Languages</li>
                                                                        <li>40 FAQs</li>
                                                                        <li>6 Intents</li>
                                                                        <li>Dashboard with reports</li>
                                                                        <li>Delegate chat to humans</li>
                                                                        <li>Unlimited messages</li>
                                                                    </ul>
                                                                </div>
                                                                <div className="pric_footer">
                                                                    <button className="btn btn-arrow" onClick={this.changePlan}>
                                                                        <span>Change Plan
                                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                                                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style={{
                                                            display: this.state.planName === "PREMIUM" ? "block" : "none"
                                                        }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginLeft: '23px', marginTop: "10px"
                                                            }}>Your selected plan:</h6><br />
                                                            <div className="priceCard tborder primeclr" style={{ marginLeft: '23px', minHeight: "600px" }}>
                                                                <div className="pric_head">
                                                                    <h3 className="planTitle" style={{ color: "blue" }}>{this.state.planName}</h3>
                                                                    <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB" }}>
                                                                        <span><b>₹ 6,000</b></span>
                                                                        <span style={{ fontSize: "16px" }}> / recharge</span>
                                                                    </h4>
                                                                    <table id="customers">
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <th className="planPrice" colSpan="2"
                                                                                style={{ fontSize: "16px", color: '#0d66d5', background: 'transparent', textAlign: 'center' }}>Usage Charges</th>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px", width: '50%' }}>
                                                                            <td>Text Chat</td>
                                                                            <td>₹ 0.9 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Voice Chat</td>
                                                                            <td>₹ 1.95 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Asr Api</td>
                                                                            <td>₹ 1.75 / minute</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                <div className="pric_body">
                                                                    <ul className="priceFeature" id="premiumPlan">
                                                                        <li>Agent on website widget &amp; popular social platforms</li>
                                                                        <li>6 Languages</li>
                                                                        <li>90 FAQs, 4 Documents</li>
                                                                        <li>15 Intents</li>
                                                                        <li>Dashboard with reports</li>
                                                                        <li>Delegate chat to humans</li>
                                                                        <li>Unlimited messages</li>
                                                                    </ul>
                                                                </div>
                                                                <div className="pric_footer">
                                                                    <button className="btn btn-arrow" onClick={this.changePlan}>
                                                                        <span>Change Plan
                                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                                                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style={{
                                                            display: this.state.planName === "ENTERPRISE" ? "block" : "none"
                                                        }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginLeft: '23px', marginTop: "10px"
                                                            }}>Your selected plan:</h6><br />
                                                            <div className="priceCard tborder primeclr" style={{ marginLeft: '23px', minHeight: "600px" }}>
                                                                <div className="pric_head">
                                                                    <h3 className="planTitle" style={{ color: "blue" }}>{this.state.planName}</h3>
                                                                    <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB" }}>
                                                                        <span><b>₹ 20,000</b></span>
                                                                        <span style={{ fontSize: "16px" }}> / recharge</span>
                                                                    </h4>
                                                                    <table id="customers">
                                                                        <tr className="planPrice" style={{ fontSize: "16px", textAlign: 'center' }}>
                                                                            <th className="planPrice" colSpan="2"
                                                                                style={{ fontSize: "16px", color: '#0d66d5', background: 'transparent', textAlign: 'center' }}>Usage Charges</th>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px", width: '50%' }}>
                                                                            <td>Text Chat</td>
                                                                            <td>₹ 0.8 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Voice Chat</td>
                                                                            <td>₹ 1.95 / minute</td>
                                                                        </tr>
                                                                        <tr className="planPrice" style={{ fontSize: "16px" }}>
                                                                            <td>Asr Api</td>
                                                                            <td>₹ 1.75 / minute</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                <div className="pric_body">
                                                                    <ul className="priceFeature" id="enterprisePlan">
                                                                        <li>Agent on website widget &amp; popular social platforms</li>
                                                                        <li>9 Languages</li>
                                                                        <li>Upto 300 FAQs, 10 Documents</li>
                                                                        <li>Upto 60 Intents</li>
                                                                        <li>Dashboard with reports</li>
                                                                        <li>Delegate chat to humans</li>
                                                                        <li>Unlimited messages</li>
                                                                    </ul>
                                                                </div>
                                                                <div className="pric_footer">
                                                                    <button className="btn btn-arrow" onClick={this.changePlan}>
                                                                        <span>Change Plan
                                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                                                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div style={{
                                                            display: this.state.planName === "ENTERPRISE_PLUS" ? "block" : "none"
                                                        }}>
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65',
                                                                marginLeft: '23px', marginTop: "10px"
                                                            }}>Your selected plan:</h6><br />
                                                            <div className="priceCard tborder primeclr" style={{ marginLeft: '23px', minHeight: "600px" }}>
                                                                <div className="pric_head">
                                                                    <h3 className="planTitle" style={{ color: "blue" }}>{this.state.planName}</h3>
                                                                    <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB" }}>
                                                                        <span className="enterprise1"><b><span style={{ fontSize: "10px" }}>Starting from</span>&nbsp;&nbsp;₹ 2 Lakh</b></span>
                                                                        <span className="enterprise1" style={{ fontSize: "10px" }}> / month</span>
                                                                    </h4>
                                                                </div>
                                                                <div className="pric_body">
                                                                    <ul className="priceFeature" id="enterprisePlan">
                                                                        <li>Completely customized</li>
                                                                    </ul>
                                                                </div>
                                                                <div className="pric_footer">
                                                                    <button className="btn btn-arrow" onClick={this.changePlan}>
                                                                        <span>Change Plan
                                                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                                                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                                <g>
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6" style={{
                                                        display: this.state.billingType == "UTTERANCE_BASED" ? "block" : "none"
                                                    }}>
                                                        <h6 className="nav-item" style={{
                                                            color: '#282a65',
                                                            marginLeft: '23px', marginTop: "10px"
                                                        }}>Your selected plan:</h6>
                                                        <div className="pric_head">
                                                            <h4 className="planPrice" style={{ backgroundColor: "white" }}>
                                                                <span style={{ fontSize: "18px", color: "blue" }}>Your billing type is <b>Utterance based</b>.</span>
                                                            </h4><br />
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65'
                                                            }}>Pricing details : </h6>
                                                            <ReactTable
                                                                data={this.state.utteranceData}
                                                                columns={utteranceBasedColumns}
                                                                defaultPageSize={3}
                                                                showPagination={false}
                                                                style={{
                                                                    backgroundColor: 'white',
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="pric_body">
                                                            <ul className="priceFeature" id="starterPlan">
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6" style={{
                                                        display: this.state.billingType == "FIXED_PRICE" ? "block" : "none"
                                                    }}>
                                                        <h6 className="nav-item" style={{
                                                            color: '#282a65',
                                                            marginLeft: '23px', marginTop: "10px"
                                                        }}>Your selected plan:</h6>
                                                        <div className="pric_head">
                                                            <h4 className="planPrice" style={{ backgroundColor: "white" }}>
                                                                <span style={{ fontSize: "18px", color: "blue" }}>Your billing type is <b>Fixed Price</b>.</span>
                                                            </h4><br />
                                                            <h6 className="nav-item" style={{
                                                                color: '#282a65'
                                                            }}>Pricing details : </h6>
                                                            <ReactTable
                                                                columns={fixedMonthlyColumns}
                                                                defaultPageSize={0}
                                                                showPagination={false}
                                                                style={{
                                                                    backgroundColor: 'white',
                                                                    marginTop: '25px'
                                                                }}
                                                                noDataText=''
                                                            />
                                                        </div>
                                                        <div className="pric_body">
                                                            <ul className="priceFeature" id="starterPlan">
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" style={{ display: this.state.showPayToWallet ? 'block' : 'none' }}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ height: "auto" }}>
                            <div className="modal-header noBorder">
                                <button type="button" className="close" data-dismiss="modal" onClick={this.closeshowPayToWallet}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                        <path d="M0 0h24v24H0z" fill="none" />
                                    </svg>
                                </button>
                            </div>
                            <div className="modal-body"
                                style={{ display: this.state.invalidBillingSettingEmail ? 'none' : 'block' }}
                                align="center">
                                <h3>
                                    Buy credits worth <i class="fa fa-inr" />{parseFloat(this.state.planAmountAfterDiscount)}<br /> before you deploy<br />
                                </h3>
                                <h6 style={{ display: this.state.currentProjectPlan == 'FREE' ? 'none' : 'block' }}>
                                    These credits will be adjusted in your invoice<br /> as per usage
                                </h6>
                                <div className="modal-footer noBorder">
                                    <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.makePayment}>Pay Now</button>
                                </div>
                            </div>
                            <div className="modal-body" align="center"
                                style={{ display: this.state.invalidBillingSettingEmail ? 'block' : 'none' }}
                            >
                                <h5 className="nav-item"
                                    style={{
                                        color: '#282a65'
                                    }}>Looks like you haven't filled necessary</h5>
                                <h5 className="nav-item"
                                    style={{
                                        color: '#282a65', marginTop: '10px'
                                    }}>billing information.</h5>
                                <h5 className="nav-item"
                                    style={{
                                        color: '#282a65', marginTop: '10px'
                                    }}>Please update them in the billing settings before you deploy
                                </h5>
                                <div align="center">
                                    <a href={window.origin + "/platform/projectmgmt/billing-setting"}>Click here</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DialogComponent width='250px' style={{ position: "fixed" }} animationSettings={this.settings}
                    header='Project Undeploy' showCloseIcon={true} buttons={this.undeployButton}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideUndeployConfirmation} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Are you sure you want to
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;undeploy project?</DialogComponent>

                <DialogComponent width='300px' style={{ position: "fixed" }} animationSettings={this.settings}
                    header='Listed in botstore!' showCloseIcon={true} buttons={this.unlistApp}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.dispUnlistAppConfirmation} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Undeploying this project will unlist the bot
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;from the botstore. Go ahead?</DialogComponent>

                <DialogComponent width='400px' height='180px' style={{ position: "fixed" }} animationSettings={this.settings}
                    showCloseIcon={true} header='Pending payment alert'
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.displayPendingPaymentModal} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />
                    <span style={{ fontSize: '14px', lineHeight: '25px', color: '#282a65', }}>
                        &nbsp;
                        There is an invoice pending payment for this project.<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Please go to <a href={window.origin + "/platform/invoice"}>
                            /myaccounts/invoice</a> and make the
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;payment before deploying your project
                    </span>
                </DialogComponent>





            </div >
        );
    }
}
export default StatusPage;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/StatusPage.js